import { Theme } from "@mui/material";

const aiWizardModalStyles = {
  htmlOutput: (theme: Theme) => ({
    height: "25vh",
    maxHeight: "25vh",
    overflowY: "auto",
    overflowX: "hidden",
    wordBreak: "break-word",

    padding: "1rem",
    border: "1px dashed",
    borderRadius: "4px",
    borderColor: theme.palette.action.disabledBackground,
  }),
};

export default aiWizardModalStyles;
